import { mastraClient } from '@/lib/mastra-client';

export async function fetchAgents() {
  return mastraClient.listAgents();
}
